import { Inject, Injectable } from '@angular/core';

import { Browser } from '@capacitor/browser';

import { EnvironmentInterface, GlobalsClientInterface } from '../../types';

@Injectable({
    providedIn: 'root'
})
export class LinksService {
    private globals: GlobalsClientInterface;
    private env: EnvironmentInterface;

    constructor(
        @Inject('globals') globals: GlobalsClientInterface,
        @Inject('environment') environment: EnvironmentInterface
    ) {
        this.globals = globals;
        this.env = environment;
    }

    //Opens in in-app browser
    openPage(url: string, target?: string) {
        Browser.open({ url, windowName: target || '_blank' });
    }

    getWebsiteUrl(path: 'faq' | 'terms-of-use' | 'privacy-policy' | string) {
        if (path === 'faq') {
            return this.globals.faqUrl;
        } else if (path === 'terms-of-use') {
            return this.globals.tosUrl;
        } else if (path === 'privacy-policy') {
            return this.globals.ppUrl;
        } else {
            return `${this.env.website}/${path}`;
        }
    }

    viewFAQ() {
        const url = this.globals.faqUrl || null;
        if (!url) return;
        this.openPage(url);
    }

    viewTermsInBrowser() {
        const url = this.globals.tosUrl || null;
        if (!url) return;
        this.openPage(url);
    }

    viewPPInBrowser() {
        const url = this.globals.ppUrl || null;
        if (!url) return;
        this.openPage(url);
    }

    viewBecomeAProInBrowser() {
        const url = this.env.website + '/become-a-primped-pro';
        this.openPage(url);
    }
}
